import { useCookies } from "@vueuse/integrations/useCookies";

import { COOKIE_SETTINGS } from "@/utils/cookies";
import { computed } from "vue";
const cookies = useCookies();
const NEW_FEATURE_ANNOUNCEMENT = "new-feature-announcement";
export const newFeatureCookieName = "assign_roles_to_your_team";

type Feature = typeof newFeatureCookieName;

export const isFeatureAnnouncementModalSeen = computed(
  () => cookies.get(NEW_FEATURE_ANNOUNCEMENT)?.[newFeatureCookieName],
);

export const setCookie = (feature: Feature) =>
  cookies.set(
    NEW_FEATURE_ANNOUNCEMENT,
    {
      ...cookies.get(NEW_FEATURE_ANNOUNCEMENT),
      [feature]: true,
    },
    COOKIE_SETTINGS,
  );
